module.exports = __webpack_public_path__ + "media/img/corporate/targeted_email_image-c9a5d23e582c0776a904137711be3406.png";